// axaGoalDashboard
export const AXA_GOAL_LEVEL_NEWBIE = 'NEWBIE';
export const AXA_GOAL_LEVEL_CRYSTAL = 'CRYSTAL';
export const AXA_GOAL_LEVEL_JADE = 'JADE';
export const AXA_GOAL_LEVEL_DIAMOND = 'DIAMOND';

export const AXA_GOAL_SH_LEVEL_NEWBIE = 'NEWBIE';
export const AXA_GOAL_SH_LEVEL_NEWBIE_ACHIEVED = 'NEWBIE_ACHIEVED';

export const AXA_GOAL_DASHBOARD_SCENARIO_1 = '1';
export const AXA_GOAL_DASHBOARD_SCENARIO_2 = '2';
export const AXA_GOAL_DASHBOARD_SCENARIO_3 = '3';
export const AXA_GOAL_DASHBOARD_SCENARIO_4 = '4';
export const AXA_GOAL_DASHBOARD_SCENARIO_5 = '5';
export const AXA_GOAL_DASHBOARD_SCENARIO_6 = '6';

export const OWNER_ROLE_NAME = 'OWN';
export const INSURED_ROLE_NAME = 'INS';
export const NUMBER_OF_MAX_CARD_SHOWING = 5;
